import type { DataQuality } from '@/api/dataQuality'

import { coverageTooltip, formatTrackedShare, isLowCoverage, trackedPercent } from './dataQuality'
import { TooltipBadge } from './TooltipBadge'
import './data-quality.css'

/**
 * "62% of orders tracked", beside the TmT source badge: how many of the range's orders
 * carry a tracked visit, with what is not tracked in its tooltip. Amber below
 * `LOW_COVERAGE_PERCENT`. Nothing when the API sent no coverage or no share (no orders).
 */
export function CoverageIndicator({ dataQuality }: { dataQuality: DataQuality | null | undefined }) {
  const coverage = dataQuality?.coverage
  const percent = trackedPercent(coverage?.trackedShare)
  if (!dataQuality || !coverage || percent === null) return null
  const low = isLowCoverage(percent)
  return (
    <span className="ci-coverage" data-coverage={low ? 'low' : 'ok'}>
      <TooltipBadge
        tone={low ? 'warning' : 'neutral'}
        label={`${formatTrackedShare(coverage.trackedShare)} of orders tracked`}
        tooltip={coverageTooltip(coverage, percent, dataQuality.trackingReliableFrom)}
        className="ci-coverage__badge"
      />
    </span>
  )
}
